namespace GeniuzPOS.Inventory {
    export interface IcStockCountTranRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        PluCode?: string;
        ItemRemark?: string;
        QtyCount?: number;
        SellUnit?: string;
        SellUnitRatio?: number;
        SkuCode?: string;
        StkQtyCount?: number;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        UnitCost?: number;
        StkCostValue?: number;
        QtyOnhand?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace IcStockCountTranRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockCountTran';
        export const deletePermission = '2Inventory:ตรวจนับ:บันทึกรายการ:Modify';
        export const insertPermission = '2Inventory:ตรวจนับ:บันทึกรายการ:Modify';
        export const readPermission = '2Inventory:ตรวจนับ:บันทึกรายการ:View';
        export const updatePermission = '2Inventory:ตรวจนับ:บันทึกรายการ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            PluCode = "PluCode",
            ItemRemark = "ItemRemark",
            QtyCount = "QtyCount",
            SellUnit = "SellUnit",
            SellUnitRatio = "SellUnitRatio",
            SkuCode = "SkuCode",
            StkQtyCount = "StkQtyCount",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            UnitCost = "UnitCost",
            StkCostValue = "StkCostValue",
            QtyOnhand = "QtyOnhand",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
